import axios from "axios";
import { apiUrl } from "../constant";

export const extractOcrService = (file) => {
  const formData = new FormData();
  formData.append("image", file);
  return axios.post(`${apiUrl}/ExtractOcr`, formData);
};

export const scanAddressService = (file, addressType) => {
  const formData = new FormData();
  formData.append("image", file);
  formData.append("addressType", addressType);
  return axios.post(`${apiUrl}/ScanAddress`, formData);
};
